
import { mapState } from 'vuex'
import vipSettings from '~/mixins/pages/mission-control/vipSettings'
export default {
    name: 'Theme2DesktopProfilesMyProfile',
    mixins: [vipSettings],
    data() {
        return {
            tab: 0,
        }
    },
    computed: {
        ...mapState({
            loadingPlayer: (state) => state.player.loading,
        }),
    },
    watch: {
        tab(value) {
            if (value === 0) this.$router.push({ query: {} })
            else this.$router.push({ query: { tab: value } })
        },
        '$route.query.tab'(value) {
            if (value === '1') this.tab = 1
            else this.tab = 0
        },
    },
    mounted() {
        if (
            this.$route.query.tab &&
            this.$route.query.tab === '1' &&
            this.isVipActive
        ) {
            this.tab = 1
        }
    },
}
